import lazyLoad from 'app/shared-components/util/lazyLoad';

const ProgramProfile = lazyLoad(() => import('app/shared-components/organization/ProgramProfile'));
const LocationProfile = lazyLoad(() => import('app/shared-components/organization/LocationProfile'));
const OrganizationProfile = lazyLoad(() => import('app/shared-components/organization/OrganizationProfile'));


const OrgProfileAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
	{
      path: '/organization/:organizationId',
      element: <OrganizationProfile />,
    },
    {
      path: '/program/:programId',
      element: <ProgramProfile />,
    },
    {
      path: '/location/:locationId',
      element: <LocationProfile />,
    },
    {
      path: '/organization/:organizationId/program/:programId',
      element: <ProgramProfile />,
    },
    {
      path: '/organization/:organizationId/location/:locationId',
      element: <LocationProfile />,
    },
  ],
};

export default OrgProfileAppConfig;
